import clsx from "clsx";
import Link from "next/link";
import { useRouter } from "next/router";
import type * as React from "react";

import { sidebarLinks } from "~/utils/constants";

type DashboardLayoutSidebarProps = {};

const DashboardLayoutSidebar: React.FC<DashboardLayoutSidebarProps> = ({}) => {
	const { asPath } = useRouter();

	return (
		<aside className="z-10 laptop:flex hidden w-56 shrink-0 flex-col gap-3 border-r bg-white px-3.5 py-4 dark:bg-slate-800">
			{sidebarLinks.map((link) => (
				<Link
					key={link.href}
					href={link.href}
					className={clsx(
						"relative flex items-center gap-2.5 rounded-full px-3.5 py-2 text-center font-medium transition-colors",
						asPath?.startsWith(link.href)
							? "bg-sky-50 text-sky-800 dark:bg-sky-300/20 dark:text-sky-200"
							: "text-slate-700 hover:bg-slate-50 dark:text-slate-100 dark:hover:bg-slate-700/50",
					)}
				>
					<link.icon className="inline-block size-5 shrink-0" />

					{link.label}
				</Link>
			))}
		</aside>
	);
};

export default DashboardLayoutSidebar;
